<app-header></app-header>
<app-silder></app-silder>
<app-product [item]="datas"></app-product>
<app-review [listReview] = "listReview"></app-review>
<app-contact></app-contact>
<app-footer></app-footer>

